import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=360f6c46&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/qd-chilecashy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360f6c46"]])

export default __exports__